"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unSign = exports.sign = exports.setCookie = void 0;
const cookie_1 = require("cookie");
const hmac_1 = require("./hmac");
const TOKEN_SEPARATOR = ".";
const cookieOptions = {
    httpOnly: true,
    sameSite: "strict",
    secure: true,
    path: "/",
};
const setCookie = (res, name, value) => {
    let valueArray = [(0, cookie_1.serialize)(name, value, cookieOptions)];
    let existingCookieHeader = res.getHeader("Set-Cookie");
    if (existingCookieHeader) {
        // Convert non-string values to string.
        if (typeof existingCookieHeader === "number") {
            existingCookieHeader = String(existingCookieHeader);
        }
        // Wrap in array so we can concat/filter.
        if (!(existingCookieHeader instanceof Array)) {
            existingCookieHeader = [existingCookieHeader];
        }
        // Remove existing filter items containing string <name>=, because those are values we want to override.
        existingCookieHeader = existingCookieHeader.filter((cookieItem) => !cookieItem.includes(`${name}=`));
        valueArray = valueArray.concat(existingCookieHeader);
    }
    res.setHeader("Set-Cookie", valueArray);
};
exports.setCookie = setCookie;
const sign = async (value) => {
    return `${value}${TOKEN_SEPARATOR}${await (0, hmac_1.getHmac)(value)}`;
};
exports.sign = sign;
const unSign = async (value) => {
    const tentativeValue = value.slice(0, value.lastIndexOf(TOKEN_SEPARATOR));
    const expectedInput = await (0, exports.sign)(tentativeValue);
    if ((0, hmac_1.timeSafeCompare)(value, expectedInput)) {
        return tentativeValue;
    }
    return null;
};
exports.unSign = unSign;
//# sourceMappingURL=cookies.js.map